var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 271 330",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M780.935 596.818c3.367 11.804 5.051 24.608 5.051 38.409 0 24.774-5.426 46.255-16.277 64.443-10.851 18.188-26.271 32.221-46.26 42.099-19.989 9.878-43.547 14.817-70.675 14.817h-52.256v86.08h-84.81V596.818h84.81v86.388h47.116c17.419 0 30.555-4.155 39.407-12.465 8.852-8.31 13.278-20.148 13.278-35.514 0-15.365-4.426-27.282-13.278-35.749a37.678 37.678 0 0 0-3.104-2.66h96.998Zm-265.227-16.555v-66.864h137.066c27.128 0 50.686 4.939 70.675 14.817 19.989 9.878 35.409 23.989 46.26 42.334a108.26 108.26 0 0 1 5.1 9.713H515.708Z",
    style: {
      fill: "#ec202d",
      fillRule: "nonzero"
    },
    transform: "translate(-515.708 -513.399)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e535d23bfe4b42c486bac201018886db.svg";
export { ForwardRef as ReactComponent };